import React, { Component } from "react";
import firebase from "@firebase/app";
import "@firebase/firestore";

class ExportDetail extends Component {
  constructor(props) {
    super(props);

    this.state = {
      season: null,
      error: null,
    };
  }

  componentDidMount() {
    const { match } = this.props;
    const seasonId = match.params.seasonId;

    const firestore = firebase.firestore();
    const seasonRef = firestore.collection("seasons").doc(seasonId);

    let season;

    seasonRef
      .get()
      .then((doc) => {
        if (doc.exists) {
          season = {
            id: doc.id,
            ...doc.data(),
          };

          const matchesRef = seasonRef.collection("matches");
          const matchesQuery = matchesRef.orderBy("id", "asc");

          let matches = [];

          matchesQuery.get().then((docs) => {
            docs.forEach((doc) => {
              matches.push({
                id: doc.id,
                ...doc.data(),
              });
            });

            this.setState({
              season,
              matches,
            });
          });
        } else {
          this.setState({ error: "Season not found" });
        }
      })
      .catch((error) => {
        this.setState({ error });
      });
  }

  render() {
    const { season, matches, error } = this.state;

    if (!season || !matches) {
      return <p>Loading...</p>;
    }

    if (error) {
      return <p>ERROR: {error}</p>;
    }

    return (
      <div className="export-detail">
        <div>
          <a href="/export">&lt; Back to Seasons</a>
        </div>
        <br />
        <h1>
          <strong>Season: {season.id}</strong>
        </h1>
        <br />
        <h2>
          <strong>Matches</strong>
        </h2>
        <div>
          {matches.map((match) => {
            let classes = ["export-match"];
            if (match.forfeit) classes.push("forfeit");
            if (match.voided) classes.push("void");
            return (
              <div key={match.id} className={classes.join(" ")}>
                <h3>
                  <strong>ID: {match.id}</strong>
                </h3>
                <p>
                  Type: {match.type} Date:{" "}
                  {match.date.toDate().toLocaleString()}
                </p>
                <div>
                  {match.voided && (
                    <p>
                      THIS MATCH WAS VOID (probably due to an appeal etc). Look
                      for a replay with ID: {match.id}R
                    </p>
                  )}
                  {match.forfeit && (
                    <p>
                      THIS MATCH WAS FORFEIT VICTORY (probably due to the losing
                      team not having enough players)
                    </p>
                  )}
                </div>
                <div>
                  {match.rounds &&
                    match.rounds.map((round) => (
                      <div key={round.id}>
                        Round {round.id}: {round.teams.home.id}{" "}
                        {round.teams.home.score} - {round.teams.away.score}{" "}
                        {round.teams.away.id}
                        {!round.scorebox && (
                          <p>
                            No scorebox available. Scores were probably still
                            posted to Forums at this time (or match was forfeit)
                          </p>
                        )}
                        {round.scorebox && (
                          <pre>{round.scorebox.replace(/\\n/g, "\n")}</pre>
                        )}
                      </div>
                    ))}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

export default ExportDetail;



// WEBPACK FOOTER //
// ./src/pages/export/detail/detail.js